function AppTitle ({ className, children }) {
    return (
        <div className={`text-3xl text-yellow-300 drop-shadow-retro-sm ${className || ''}`}>{ children }</div>
    );
}

export default AppTitle;